module.exports = __webpack_public_path__ + "static/img/about11.abcdb58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about11.png
// module id = wCv2
// module chunks = 1